export default __webpack_public_path__ + "static/media/discord.d1bd06e1.svg";